module.exports = __webpack_public_path__ + "img/LightCastle 1.10c187af.png";